// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

.helmet {
    display: block;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    height: 42px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

html {
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    min-height: 100%;
    overflow: visible;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.brandedCardContent {
    background-color: white;
    border-style: solid;
}

.cardMainContentOuter {
    min-height: 536px;
}

.cardMainContentInner {
    min-height: 494px;
}

.brandedCardContainer {
    /* border-style: solid; */
    background-color: white;
    min-height: 494px;
    padding: 25px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

.brandedCard {
    position: absolute;
    left: 5px;
    right: 5px;
    top: 3px;
    bottom: 6px;
    background: #ffffff;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    border-style: solid;
}

.errorMessage {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #202020;
}

.noteText {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #202020;
}

.headerText {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #202020;
}

.actualContent {
    font-size: 20px;
}

.loadedContent {
    width: 90%;
}

.linkText {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    letter-spacing: -0.2px;
    color: #0070a9;
}

.errorLabelAsterisk {
    color: #b00 !important;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline !important;
}

.invalidOrExpiredInstActText {
    font-family: Barlow;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    position: relative;
    top: -80px;
}

.invalidOrExpiredInstActTextOneSite {
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    position: relative;
    top: -80px;
}

/* ProtoType Signin */
.paper {
    display: 'flex';
    flex-direction: 'column';
    align-items: 'center';
}

/* .avatar {
    margin: 8px;
    background-color: theme.palette.secondary.main,
  } */
.form {
    width: '100%';
    margin-top: 8px;
}

.submit {
    margin: 24px, 0px, 16px;
}

/* common styles */
.bgwhite {
    background: #ffffff;
}

.txtAlignCenter {
    text-align: center;
}

.txtDecorationNone {
    text-decoration: none;
}

.pd0 {
    padding: 0;
}

.pdl0 {
    padding-left: 0;
}

.pdr0 {
    padding-right: 0;
}

.mh39 {
    min-height: 39px;
}

.mh144 {
    min-height: 144px;
}

.displayFlex {
    display: flex;
}

.h60 {
    height: 60px;
}

.h80 {
    height: 80px;
}

.mb12 {
    margin-bottom: 12px;
}

.btn-spinner > .MuiCircularProgress-colorPrimary {
    color: #ebe7e7a8;
    width: 1.25rem !important;
    height: 1.25rem !important;
}

.input-error .MuiInputBase-root > input {
    color: #f44336;
}

.input-error .MuiInput-underline.Mui-error:after {
    border: none;
}

.input-error .MuiFormControl-root > p {
    display: none;
}

.mb-4 {
    margin-bottom: 4rem !important;
}

.mb-1 {
    margin-bottom: 1rem !important;
}

.mt-1 {
    margin-top: 1rem !important;
}

.ml-1 {
    margin-left: 1rem !important;
}

.mb5 {
    margin-bottom: 5px !important;
}

.minHeight-7 {
    min-height: 7rem;
}

.dFlex {
    display: flex;
}

.my-1 {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.alignSelfCenter {
    align-self: center;
}

/* APP Promotion */
.promotionContainer {
    display: flex;
    width: 100%;
    height: 535px;
    max-width: 850px;
}

.promotionImageContainer {
    position: relative;
    flex-basis: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.promotionImage {
    position: absolute;
    z-index: 1;
}

.promotionColorBlock {
    position: absolute;
    width: 100%;
    margin-right: 5%;
    height: 265px;
    border-bottom-right-radius: 205px;
    border-top-right-radius: 205px;
}

.promotionContentContainer {
    flex-basis: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.promotionContentBrandLogo {
    max-width: 36%;
}

h1.promotionContentHeading {
    font-family: Barlow;
    font-size: 48px;
    font-weight: 900;
    line-height: 34px;
    margin-bottom: 10px;
    margin-top: 10px;
    text-transform: uppercase;
}

h1.promotionContentBrandHeading {
    font-family: Barlow;
    font-size: 36px;
    font-weight: 500;
    line-height: 34px;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.promotionContentTextContainer {
    margin-bottom: 40px;
}

.promotionContentTextContainer ul {
    padding-left: 25px;
}

p.promotionContentText,
li.promotionContentText {
    font-family: Barlow;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
}

.promotionContentContainer .scannerImage {
    width: 83px;
    height: 84px;
    position: relative;
    border: 1px;
    left: 8%;
    margin-top: 5px;
}

.PromotionDialog .MuiDialog-paperWidthSm {
    max-width: 850px;
}

.PromotionDialog .MuiButtonBase-root.closeButton {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
}

.PromotionDialog .MuiDialogContent-root {
    padding: 0px;
}

.hidden {
    display: none !important;
}

.promotionWebButtons {
    max-height: 180px;
}

.hoverHiddenBtn.MuiButton-root:hover {
    background-color: transparent;
}

@media only screen and (max-device-width: 750px) {
    .promotionContainer {
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .promotionImageContainer {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        max-height: 60%;
    }

    .PromotionDialog .MuiDialog-container .MuiDialog-scrollPaper .MuiDialog-paperWidthSm {
        max-width: 100%;
    }

    .PromotionDialog .MuiDialog-paperScrollPaper {
        max-height: calc(100% - 20px);
        height: 100%;
    }

    .PromotionDialog .MuiDialog-paper {
        margin: 10px;
    }

    .promotionImage {
        position: relative;
        width: 50%;
        display: flex;
        justify-content: center;
    }

    .promotionImage img {
        height: 45vh;
    }

    .promotionColorBlock {
        width: 95%;
        height: 60%;
    }

    .mb5 {
        margin-bottom: 2px;
    }

    h1.promotionContentHeading {
        font-size: 38px;
        margin-bottom: 0.5vh;
        margin-top: 1vh;
        line-height: 5vh;
    }

    h1.promotionContentBrandHeading {
        font-size: 28px;
        margin-bottom: 0px;
        line-height: 3vh;
    }

    .promotionContentTextContainer {
        margin-bottom: 3vh;
        margin-top: 1vh;
    }

    .promotionButtonContainer .MuiGrid-container .MuiGrid-container .MuiButton-contained {
        min-width: 160px;
        margin-left: -30px;
    }
}

/* APP promotion in small device 
   Reduce Image size and stack the buttons
*/
@media only screen and (max-device-width: 300px) {
    .promotionImage img {
        height: 30vh;
    }
    .promotionImageContainer {
        flex-basis: 35%;
    }
    .promotionButtonContainer .MuiGrid-justify-xs-space-around {
        flex-direction: column-reverse;
        align-items: center;
        min-height: 110px;
    }
    .promotionButtonContainer .MuiGrid-container .MuiGrid-container .MuiButton-contained {
        margin-left: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;;;KAGK;AACL;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;;CAEC;AACD;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n.helmet {\n    display: block;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n    height: 42px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\nhtml {\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    min-height: 100%;\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.brandedCardContent {\n    background-color: white;\n    border-style: solid;\n}\n\n.cardMainContentOuter {\n    min-height: 536px;\n}\n\n.cardMainContentInner {\n    min-height: 494px;\n}\n\n.brandedCardContainer {\n    /* border-style: solid; */\n    background-color: white;\n    min-height: 494px;\n    padding: 25px;\n    border-bottom-right-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.brandedCard {\n    position: absolute;\n    left: 5px;\n    right: 5px;\n    top: 3px;\n    bottom: 6px;\n    background: #ffffff;\n    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);\n    border-radius: 10px;\n    border-style: solid;\n}\n\n.errorMessage {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: #202020;\n}\n\n.noteText {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 14px;\n    color: #202020;\n}\n\n.headerText {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n\n    color: #202020;\n}\n\n.actualContent {\n    font-size: 20px;\n}\n\n.loadedContent {\n    width: 90%;\n}\n\n.linkText {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 17px;\n    text-align: right;\n    letter-spacing: -0.2px;\n    color: #0070a9;\n}\n\n.errorLabelAsterisk {\n    color: #b00 !important;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 15px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: inline !important;\n}\n\n.invalidOrExpiredInstActText {\n    font-family: Barlow;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0px;\n    text-align: center;\n    position: relative;\n    top: -80px;\n}\n\n.invalidOrExpiredInstActTextOneSite {\n    font-family: Montserrat;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0px;\n    text-align: center;\n    position: relative;\n    top: -80px;\n}\n\n/* ProtoType Signin */\n.paper {\n    display: 'flex';\n    flex-direction: 'column';\n    align-items: 'center';\n}\n\n/* .avatar {\n    margin: 8px;\n    background-color: theme.palette.secondary.main,\n  } */\n.form {\n    width: '100%';\n    margin-top: 8px;\n}\n\n.submit {\n    margin: 24px, 0px, 16px;\n}\n\n/* common styles */\n.bgwhite {\n    background: #ffffff;\n}\n\n.txtAlignCenter {\n    text-align: center;\n}\n\n.txtDecorationNone {\n    text-decoration: none;\n}\n\n.pd0 {\n    padding: 0;\n}\n\n.pdl0 {\n    padding-left: 0;\n}\n\n.pdr0 {\n    padding-right: 0;\n}\n\n.mh39 {\n    min-height: 39px;\n}\n\n.mh144 {\n    min-height: 144px;\n}\n\n.displayFlex {\n    display: flex;\n}\n\n.h60 {\n    height: 60px;\n}\n\n.h80 {\n    height: 80px;\n}\n\n.mb12 {\n    margin-bottom: 12px;\n}\n\n.btn-spinner > .MuiCircularProgress-colorPrimary {\n    color: #ebe7e7a8;\n    width: 1.25rem !important;\n    height: 1.25rem !important;\n}\n\n.input-error .MuiInputBase-root > input {\n    color: #f44336;\n}\n\n.input-error .MuiInput-underline.Mui-error:after {\n    border: none;\n}\n\n.input-error .MuiFormControl-root > p {\n    display: none;\n}\n\n.mb-4 {\n    margin-bottom: 4rem !important;\n}\n\n.mb-1 {\n    margin-bottom: 1rem !important;\n}\n\n.mt-1 {\n    margin-top: 1rem !important;\n}\n\n.ml-1 {\n    margin-left: 1rem !important;\n}\n\n.mb5 {\n    margin-bottom: 5px !important;\n}\n\n.minHeight-7 {\n    min-height: 7rem;\n}\n\n.dFlex {\n    display: flex;\n}\n\n.my-1 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n\n.alignSelfCenter {\n    align-self: center;\n}\n\n/* APP Promotion */\n.promotionContainer {\n    display: flex;\n    width: 100%;\n    height: 535px;\n    max-width: 850px;\n}\n\n.promotionImageContainer {\n    position: relative;\n    flex-basis: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.promotionImage {\n    position: absolute;\n    z-index: 1;\n}\n\n.promotionColorBlock {\n    position: absolute;\n    width: 100%;\n    margin-right: 5%;\n    height: 265px;\n    border-bottom-right-radius: 205px;\n    border-top-right-radius: 205px;\n}\n\n.promotionContentContainer {\n    flex-basis: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.promotionContentBrandLogo {\n    max-width: 36%;\n}\n\nh1.promotionContentHeading {\n    font-family: Barlow;\n    font-size: 48px;\n    font-weight: 900;\n    line-height: 34px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    text-transform: uppercase;\n}\n\nh1.promotionContentBrandHeading {\n    font-family: Barlow;\n    font-size: 36px;\n    font-weight: 500;\n    line-height: 34px;\n    margin-bottom: 10px;\n    text-transform: uppercase;\n}\n\n.promotionContentTextContainer {\n    margin-bottom: 40px;\n}\n\n.promotionContentTextContainer ul {\n    padding-left: 25px;\n}\n\np.promotionContentText,\nli.promotionContentText {\n    font-family: Barlow;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 19px;\n}\n\n.promotionContentContainer .scannerImage {\n    width: 83px;\n    height: 84px;\n    position: relative;\n    border: 1px;\n    left: 8%;\n    margin-top: 5px;\n}\n\n.PromotionDialog .MuiDialog-paperWidthSm {\n    max-width: 850px;\n}\n\n.PromotionDialog .MuiButtonBase-root.closeButton {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    z-index: 1;\n}\n\n.PromotionDialog .MuiDialogContent-root {\n    padding: 0px;\n}\n\n.hidden {\n    display: none !important;\n}\n\n.promotionWebButtons {\n    max-height: 180px;\n}\n\n.hoverHiddenBtn.MuiButton-root:hover {\n    background-color: transparent;\n}\n\n@media only screen and (max-device-width: 750px) {\n    .promotionContainer {\n        flex-direction: column;\n        height: 100%;\n        width: 100%;\n    }\n\n    .promotionImageContainer {\n        display: flex;\n        position: relative;\n        align-items: center;\n        justify-content: center;\n        max-height: 60%;\n    }\n\n    .PromotionDialog .MuiDialog-container .MuiDialog-scrollPaper .MuiDialog-paperWidthSm {\n        max-width: 100%;\n    }\n\n    .PromotionDialog .MuiDialog-paperScrollPaper {\n        max-height: calc(100% - 20px);\n        height: 100%;\n    }\n\n    .PromotionDialog .MuiDialog-paper {\n        margin: 10px;\n    }\n\n    .promotionImage {\n        position: relative;\n        width: 50%;\n        display: flex;\n        justify-content: center;\n    }\n\n    .promotionImage img {\n        height: 45vh;\n    }\n\n    .promotionColorBlock {\n        width: 95%;\n        height: 60%;\n    }\n\n    .mb5 {\n        margin-bottom: 2px;\n    }\n\n    h1.promotionContentHeading {\n        font-size: 38px;\n        margin-bottom: 0.5vh;\n        margin-top: 1vh;\n        line-height: 5vh;\n    }\n\n    h1.promotionContentBrandHeading {\n        font-size: 28px;\n        margin-bottom: 0px;\n        line-height: 3vh;\n    }\n\n    .promotionContentTextContainer {\n        margin-bottom: 3vh;\n        margin-top: 1vh;\n    }\n\n    .promotionButtonContainer .MuiGrid-container .MuiGrid-container .MuiButton-contained {\n        min-width: 160px;\n        margin-left: -30px;\n    }\n}\n\n/* APP promotion in small device \n   Reduce Image size and stack the buttons\n*/\n@media only screen and (max-device-width: 300px) {\n    .promotionImage img {\n        height: 30vh;\n    }\n    .promotionImageContainer {\n        flex-basis: 35%;\n    }\n    .promotionButtonContainer .MuiGrid-justify-xs-space-around {\n        flex-direction: column-reverse;\n        align-items: center;\n        min-height: 110px;\n    }\n    .promotionButtonContainer .MuiGrid-container .MuiGrid-container .MuiButton-contained {\n        margin-left: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
